import { render } from "./ConfirmationModal.vue?vue&type=template&id=8c974914"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"
script.render = render

export default script